import process from "process";
import { useQuery } from "react-query";
import { queryKeys } from "@/queries/queryKeys";
import axios from "axios";
import { NextSeo } from "next-seo";
import LandingHeader from "@/components/Header/LandingHeader";
import Footer from "@/components/Footer/Footer";
import React from "react";
import { render } from "storyblok-rich-text-react-renderer";

export default function TermsAndConditions() {
  const url = `https://api-us.storyblok.com/v2/cdn/stories/page/terms-and-conditions/?token=${process.env.NEXT_PUBLIC_STORYBLOK_API_KEY}&version=published`;
  const { data, isLoading } = useQuery(queryKeys.termsAndConditions, () =>
    axios.get(url)
  );
  const story = data?.data?.story?.content;

  const applyNowOptions = `https://api-us.storyblok.com/v2/cdn/stories/apply-now-options?token=${process.env.NEXT_PUBLIC_STORYBLOK_API_KEY}&version=published`;
  const { data: applyNowOptionsData, isLoading: isLoadingApplyNow } = useQuery(
    queryKeys.applyNowOptions,
    () => axios.get(applyNowOptions)
  );

  const applyNow = applyNowOptionsData?.data?.story?.content;
  return (
    <>
      <NextSeo
        title="Terms And Conditions"
        openGraph={{
          title: "Terms And Conditions",
          description: "AGREEMENT BETWEEN USER",
        }}
      />
      {!isLoading && !isLoadingApplyNow && (
        <div className="landing relative overflow-hidden">
          <LandingHeader applyNowText={applyNow.apply_now_label} />
          <div className="land-container my-6 max-w-[991px] mx-auto">
            <h2 className="mb-8 text-center">{story.title}</h2>
            <div className="text-content pr-14">{render(story.content)}</div>
          </div>
          <Footer applyNowText={applyNow.apply_now_label} />
        </div>
      )}
    </>
  );
}
